module.exports = __webpack_public_path__ + "img/house_12.d64b72d9.jpg";